/** @format */

import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import { Line } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  ChartDataLabels
);

const LineChartComponent = ({ monthlyData, month }) => {
  const excludeKeys = ["birligi", "id", "nomi"];

  const labels = Object.keys(monthlyData).filter(
    (key) => !excludeKeys.includes(key)
  );

  const year2024Data = labels.map((kun) => Number(monthlyData[kun]));
  const date = new Date(month);
  const formattedDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;

  const data = {
    labels: labels.map((_, index) => (index + 1).toString()),
    datasets: [
      {
        label: formattedDate,
        data: year2024Data,
        borderColor: "#FF6384",
        backgroundColor: "rgba(255, 99, 132, 0.2)",
        fill: true,
        tension: 0.3,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { position: "top" },
      title: {
        display: true,
        text: "Tanlangan ma'lumot uchun chiziqli grafik",
      },
      tooltip: {
        callbacks: {
          title: function (tooltipItems) {
            const index = tooltipItems[0].dataIndex;
            return `${index + 1}-kun`;
          },
          label: function (context) {
            const label = context.dataset.label || "";
            const value = context.parsed.y || 0;
            return `${label}: ${value} ${monthlyData.birligi}`;
          },
        },
      },
      datalabels: null,
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: function (value) {
            return `${value} ${monthlyData.birligi}`;
          },
        },
      },
    },
  };

  return (
    <div style={{ width: "100%", minWidth: "1200px", height: "550px" }}>
      <Line data={data} options={options} />
    </div>
  );
};

export default LineChartComponent;
